// extracted by mini-css-extract-plugin
export default {"list":"animals_list__wS4zg"};